/**
 * Auto-découvert par `apps/web/src/routes/modules.ts` via :
 *   import.meta.glob('../../../modules/&star;/web/route.tsx', { eager: true })
 *
 * Convention `ModuleRoute` :
 *   { path, label, icon, element }
 *
 * On expose `element` via `lazy()` pour code-split la page principale.
 *
 * Route de détail (23/07) : suit la convention `herbo-lot-detail`
 * (`apps/web/src/routes/modules.ts` / `TopBar.tsx`) — une route top-level
 * paramétrée `commande-detail/:id` cachée de la nav (`hidden: true`), routable
 * depuis un clic sur une ligne de `CommandesTable`. Changement additif : la
 * route `commandes` existante et son onglet sont inchangés.
 */
import { lazy, Suspense, type ReactNode } from 'react';
import type { ModuleRoute } from "@herbo/module-route";

const CommandesPage = lazy(() => import('./pages/Commandes'));
const CommandeDetailPage = lazy(() => import('./pages/CommandeDetail'));

function LoadingFallback(): ReactNode {
  return (
    <div className="p-6 text-sm text-slate-500" role="status" aria-live="polite">
      Chargement du module Commandes…
    </div>
  );
}

const listRoute: ModuleRoute = {
  path: 'commandes',
  label: 'Commandes MP',
  icon: 'shopping-cart',
  element: (
    <Suspense fallback={<LoadingFallback />}>
      <CommandesPage />
    </Suspense>
  ),
};

const detailRoute: ModuleRoute = {
  path: 'commande-detail/:id',
  label: 'Commandes MP',
  icon: 'shopping-cart',
  hidden: true,
  element: (
    <Suspense
      fallback={
        <div className="p-6 text-sm text-slate-500" role="status" aria-live="polite">
          Chargement de la commande…
        </div>
      }
    >
      <CommandeDetailPage />
    </Suspense>
  ),
};

export default [listRoute, detailRoute];
